// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* =========================================================================
   GLOBAL MODAL SCROLL LOCK (Freezes background across all project modals)
   ========================================================================= */
html.modal-open,
body.modal-open,
html:has([class*="modal-overlay"]),
body:has([class*="modal-overlay"]),
html:has([class*="popup-overlay"]),
body:has([class*="popup-overlay"]) {
  overflow: hidden !important;
  height: 100% !important;
  overscroll-behavior: none !important;
}

/* Ensure all modal overlays contain touch events and don't bleed scroll */
[class*="modal-overlay"],
[class*="popup-overlay"] {
  overscroll-behavior: contain !important;
  -webkit-overflow-scrolling: touch !important;
}

/* Ensure all modal content cards are scrollable inside without bleeding */
[class*="modal-overlay"] > div,
[class*="popup-overlay"] > div,
.reg-users-modal-box,
.staff-modal-card,
.dept-modal-card,
.student-modal-card,
.export-modal-container,
.g-details-modal-card,
.transfer-modal-card,
.assign-modal,
.chat-modal {
  overscroll-behavior: contain !important;
  -webkit-overflow-scrolling: touch !important;
}

/* =========================================================================
   GLOBAL DYNAMIC SPINNER & KEYFRAMES
   ========================================================================= */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spin-animated {
  display: inline-block !important;
  animation: spin 0.75s linear infinite !important;
  transform-origin: center center !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;;8EAE8E;AAC9E;;;;;;EAME,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA,0EAA0E;AAC1E;;EAEE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,0EAA0E;AAC1E;;;;;;;;;;;EAWE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;;8EAE8E;AAC9E;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,0CAA0C;AAC5C","sourcesContent":["*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n#root {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* =========================================================================\r\n   GLOBAL MODAL SCROLL LOCK (Freezes background across all project modals)\r\n   ========================================================================= */\r\nhtml.modal-open,\r\nbody.modal-open,\r\nhtml:has([class*=\"modal-overlay\"]),\r\nbody:has([class*=\"modal-overlay\"]),\r\nhtml:has([class*=\"popup-overlay\"]),\r\nbody:has([class*=\"popup-overlay\"]) {\r\n  overflow: hidden !important;\r\n  height: 100% !important;\r\n  overscroll-behavior: none !important;\r\n}\r\n\r\n/* Ensure all modal overlays contain touch events and don't bleed scroll */\r\n[class*=\"modal-overlay\"],\r\n[class*=\"popup-overlay\"] {\r\n  overscroll-behavior: contain !important;\r\n  -webkit-overflow-scrolling: touch !important;\r\n}\r\n\r\n/* Ensure all modal content cards are scrollable inside without bleeding */\r\n[class*=\"modal-overlay\"] > div,\r\n[class*=\"popup-overlay\"] > div,\r\n.reg-users-modal-box,\r\n.staff-modal-card,\r\n.dept-modal-card,\r\n.student-modal-card,\r\n.export-modal-container,\r\n.g-details-modal-card,\r\n.transfer-modal-card,\r\n.assign-modal,\r\n.chat-modal {\r\n  overscroll-behavior: contain !important;\r\n  -webkit-overflow-scrolling: touch !important;\r\n}\r\n\r\n/* =========================================================================\r\n   GLOBAL DYNAMIC SPINNER & KEYFRAMES\r\n   ========================================================================= */\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.spin-animated {\r\n  display: inline-block !important;\r\n  animation: spin 0.75s linear infinite !important;\r\n  transform-origin: center center !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
